import { useCallback, useMemo, useState } from 'react'

import { Input, Tooltip } from 'antd'
import { isArray, isFunction } from 'lodash'

const { Search } = Input

const SearchList = ({ selected, data = [], maxHeight = 300, onSelectedChange }) => {
  const [search, setSearch] = useState('')

  const items = useMemo(() => {
    let items = isArray(data) ? data : []

    if (search) {
      items = items.filter(item => item.label.toLowerCase().includes(search.toLowerCase()) || item.tooltip.toLowerCase().includes(search.toLowerCase()))
    }

    return items
  }, [search, data])

  const renderItem = useCallback(item => {
    let body = ''
    let className = 'search-list-item'

    if (item.label) {
      body = <span>{item.label}</span>
    }

    if (item.value && isFunction(onSelectedChange)) {
      const isSelected = selected === item.value
      className += isSelected ? ' selected' : ''

      body = <div onClick={() => onSelectedChange(selected === item.value ? undefined : item.value)}> {body} </div>
    }

    if (item.tooltip) {
      body = <Tooltip title={item.tooltip} placement='right'> {body} </Tooltip>
    }

    return <li key={item.value ?? item.label} className={className}> {body} </li>
  }, [selected, onSelectedChange])

  return (
    <div className='search-list w-100 h-100'>
      <Search onChange={e => setSearch(e.target.value.toLowerCase())} />
      <div className='overflow-y ant-list-border' style={{ maxHeight: maxHeight + 'px' }}>
        <ul className='list-container'>
          {items.map(renderItem)}
        </ul>
      </div>
    </div>
  )
}

export default SearchList
